export const FEATURE_FLAGS = {
  COLLABORATION: "joaVRX17AcBxyCmv9onaU",
  SLACK_APP: "i8UQB4L25SrYbHN4FfAml",
  AI_AGENT: "ETQSOofSN2d5Qo5cfefz1",
  MFA_REQUIREMENT: "U66K9sJ2qD7KpzlBXm28G",
  LINKED_DATA_SOURCES: "S4zBik7YLcdhruAd6uzC_",
  // ProseMirror Text element (beta). Off → Froala for everyone.
  PROSEMIRROR_TEXT: "9JferjBWMPYpTHW0XfF_K",
  // Excel (OneDrive) entry points only — Sheets/CSV/.xlsx ride LINKED_DATA_SOURCES.
  // Excel stays hidden until the Entra app clears publisher verification.
  AI_TEMPLATES: "LdzQGMi3r_22190p1zQx5",
  AI_SLIDES: "OCG0VLQcvnK254_NfdFdR",
  STANDALONE_VERSIONS: "aXIwyiQqMYToIr9F2caGC",
  EXPORT_FORMATS: "3lL2y37X72ex8At5McgTh",
  IMPORT_FILE: "wI66nAsV90RXIayxAytCI",
  // Figma "Send flow": send versions by email, reminders, builder, bulk,
  // per-document access. Everything ships together behind this one flag.
  SEND_FLOW: "SEND_FLOW",
  PLATFORM_ONBOARDING: "1SC5smMuodikxW9k4sUV6",
  // QR code element in the add menu (Interactive elements). Codes already in a
  // story render and stay editable either way. Turn on only once the
  // static-library renderer has shipped, or live stories show the element
  // blank.
  QR_CODE: "RaoOiuVGiiei8h3S0S1Mt",
} as const;
